// extracted by mini-css-extract-plugin
export default {"notfound":"Views_notfound__v9BWK","aboutus":"Views_aboutus__HTuU-","aboutimg":"Views_aboutimg__XelTM"};